import { withTranslation } from '@common/helpers';

export const CHART_OPTIONS = () => {
  return {
    clip: false,
    responsive: true,
    maintainAspectRatio: false,
    title: {
      display: true,
    },
    layout: {
      padding: {
        right: 90,
      },
    },
    plugins: {
      title: {
        display: true,
      },
      legend: {
        display: false,
        position: 'bottom',
        align: 'center',
        labels: {
          usePointStyle: true,
          generateLabels: function (chart: any) {
            const { data } = chart;
            return data.datasets.map((dataset: any, i: number) => {
              return {
                text: dataset.label,
                fillStyle: dataset.borderColor,
                pointStyle: 'rectRounded',
                color: dataset.borderColor,
                strokeStyle: dataset.borderColor,
                fontColor: dataset.borderColor,
                index: i,
              };
            });
          },
        },
      },
      tooltip: {
        enabled: true,
      },
      datalabels: false,
    },
    scales: {
      x: {
        ticks: {
          color: '#000',
          padding: 15,
          font: {
            size: 15,
          },
        },
        grid: {
          display: false,
          drawTicks: false,
        },
        title: {
          display: true,
          text: withTranslation('accessibilityDashboard', 'Date'),
          color: '#000',
          font: {
            size: 16,
            weight: 500,
          },
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          min: 0,
          max: 100,
          stepSize: 10,
          color: '#000',
          padding: 5,
          font: {
            size: 15,
          },
        },
        title: {
          display: true,
          text: '%',
          font: {
            size: 16,
            weight: 500,
          },
          color: '#000',
        },
        max: 100,
      },
    },
    elements: {
      point: {
        pointStyle: 'rectRot',
        backgroundColor: '#5b5eff',
        borderWidth: 8,
        hoverBorderWidth: 7,
      },
    },
  };
};

const labels = ['Sep', 'Oct', 'Nov', 'Dec', 'Jen', 'Feb', 'Mar'];

export const CHART_DATA = {
  labels,
  datasets: [
    {
      label: '%',
      data: [45, 40, 29, 91, 70, 50, 60],
      borderColor: '#5b5eff',
      backgroundColor: '#5b5eff',
    },
    {
      label: 'Target',
      data: [40, 40, 40, 40, 40, 40, 40],
      borderColor: '#A80000',
      backgroundColor: '#A80000',
      borderWidth: 3,
      fill: false,
      lineTension: 0,
      pointBorderWidth: 0,
      pointBackgroundColor: '#A80000',
      pointHoverRadius: 0,
      pointRadius: 0,
      pointHitRadius: 0,
      borderDash: [10, 5],
    },
    {
      label: 'Critical',
      data: [70, 70, 70, 70, 70, 70, 70],
      borderColor: '#035E11',
      backgroundColor: '#035E11',
      borderWidth: 3,
      fill: false,
      lineTension: 0,
      pointBorderWidth: 0,
      pointBackgroundColor: '#035E11',
      pointHoverRadius: 0,
      pointRadius: 0,
      pointHitRadius: 0,
      borderDash: [10, 5],
    },
  ],
};
